import createTaskModule from '../utils/createTaskModule';
import type { TaskModuleState } from './schema/TaskModuleInstances';

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createTaskModule called at module scope is not allowed. This may cause unwanted side effects. */
export const appStoreModalStore: TaskModuleState = createTaskModule();
